import React, { useState } from 'react'
import { Steps, Card } from 'antd'
import { PageHeader } from '@components'
import ChooseSchemePage from './ChooseSchemePage'
import CreateSchemePage from './CreateSchemePage'
import PreiewSchemePage from './PreiewSchemePage'

const QualityCheckSchemeDetail = () => {
  const [current, setCurrent] = useState(0)
  const [qcType, setQcType] = useState<number>(0)
  const [qcId, setQcId] = useState<number | null>(null)
  return (
    <>
      <PageHeader title="质检方案配置" />
      <Card title="创建质检规则" className="mt20 mb20">
        <Steps
          current={current}
          items={[
            {
              title: '质检想要得到什么结果？',
              description: '选择类型：判断违规/评估销售能力/贴标签',
            },
            {
              title: '如何给出质检结果？',
              description: '描述规则：命中/豁免条件，提交大模型',
            },
            {
              title: '通知产研调优模型',
              description: '通知产研同学进一步调优模型',
            },
          ]}
        />
      </Card>
      {current === 0 && <ChooseSchemePage onChange={(qcType) => {
        setCurrent(1)
        setQcType(qcType)
        setQcId(null)
      }} />}
      {current === 1 && <CreateSchemePage qcType={qcType} qcId={qcId} onBack={() => {
        setCurrent(0)
      }} onSave={(id) => {
        setCurrent(2)
        setQcId(id)
      }} />}
      {current === 2 && <PreiewSchemePage qcType={qcType} qcId={qcId} onEdit={(id) => {
        setCurrent(1)
        setQcId(id)
      }} />}
    </>
  )
}

export default QualityCheckSchemeDetail
